
export class InputFieldConstants {
    /** Alpha value for an empty input field (indicates the user that the field is not ready yet) **/
    public static INPUT_EMPTY_ALPHA: number = 0.5;

    /** Alpha value for an filled input field **/
    public static INPUT_FILLED_ALPHA: number = 1.0;
}
